<div class="form-group mb-10">
    @if (isLoading()) {
        <div class="panel">
            <div class="panel-body block-loading"></div>
        </div>
    } @else if (isFailure()) {
        <div class="alert alert-danger">
            {{ "unknown_error" | translate }}
        </div>
    } @else {
        <div cdkDropList [cdkDropListData]="paymentElements()" (cdkDropListDropped)="dropPaymentElementItem($event)">
            @for (paymentElement of paymentElements(); track $index; let i = $index) {
                <div cdkDrag cdkDropListGroup [cdkDragData]="paymentElement">
                    <sp-control-handle
                        [controlHandleSubTextDanger]="!paymentElement?.amount"
                        [controlHandleIcon]="getPaymentElementIcon(paymentElement?.type)"
                        [controlHandleMainText]="getPaymentElementLabel(paymentElement?.type) | translate"
                        [controlHandleSubText]="isShopCart() ? '' : getPaymentElementSubText(paymentElement)"
                        [controlHandleDisableDelete]="paymentElements().length === 1"
                        (editActionEvent)="editActionEvent.emit(i)"
                        (removeActionEvent)="removePaymentElement(i)"
                    />
                </div>
            }
        </div>
    }
</div>

<a class="dotted" (click)="addPaymentElement()">
    {{ "add_payment" | translate }}
</a>
